var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFeedbackSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.688009 14.6633C0.564463 15.2171 1.00035 15.4516 1.4048 15.2747L15.0742 8.43735H15.0756C15.2387 8.34764 15.3333 8.18598 15.3333 7.9995C15.3333 7.81291 15.2387 7.65114 15.0756 7.56147H15.0742L1.4048 0.724022C1.00035 0.547106 0.564463 0.781617 0.688009 1.33545C0.69637 1.37297 1.50449 4.88442 1.94387 6.79418L9.07955 7.99946L1.94387 9.2046C1.50449 11.1142 0.696333 14.6258 0.688009 14.6633Z",
    fill: "#7783A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedbackSend);
export default __webpack_public_path__ + "static/media/icon_feedback_send.72e921bd86e240d0865bab3f8e243571.svg";
export { ForwardRef as ReactComponent };